import { RichText } from "@atlassiansox/bxp-content-framework";

import { UiCaptionModel } from "../../models";
import { renderViewModel } from "../../render-view-model";
import { MapModelToProps } from "../../utils";

import { Caption, CaptionWrapper } from "./UiCaption.styles";

export type UiCaptionProps = MapModelToProps<UiCaptionModel>;

const UiCaption = ({ model }: UiCaptionProps) => {
    const { caption, appearance } = model.content;

    return caption.content ? (
        <CaptionWrapper
            data-testid="caption"
            roundedCorners={caption.content.content.content.roundedCorners}
        >
            {renderViewModel(caption.content.content)}
            <Caption appearance={appearance}>
                <RichText document={caption.content.caption} />
            </Caption>
        </CaptionWrapper>
    ) : null;
};

export default UiCaption;
